import { Avatar, Box, Typography } from "@mui/material";
import { statratRed } from "../../../../config/constants";

export function renderUserCell(params) {
    const name = params.value;
    const username = params.row.username === '' ? params.value : params.row.username;

    return (
        <Box display='flex' flexDirection='row' gap={1}>
            <Avatar style={{ backgroundColor: statratRed }}>{name.toUpperCase().substring(0, 1)}</Avatar>
            <Box>
                <Typography>{name}</Typography>
                <Typography variant='subtitle2' color="text.secondary">{username}</Typography>
            </Box>
        </Box>
    );
}
